import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class ColorTableConverter extends CmsConverterService<ColorTableData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      table: formData.st_table ?? defaultTextInput,
      legend: formData.st_legend ?? defaultTextInput,
      caption: formData.st_caption ?? defaultTextInput
    }
  }
}

export const COLOR_TABLE_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, ColorTableData>>('ColorTableConverter')

export interface ColorTableData extends ConvertedComponentData {
  table: TextInput;
  legend: TextInput;
  caption: TextInput;
}
